import ApplicationController from './application_controller'
import consumer from '../channels/consumer'
import CableReady from 'cable_ready'

// Givsum 3.0 vanilla-JS counterpart to auction_item_controller.js (jQuery-based, untouched).
// Subscribes to the per-item AuctionItemChannel so bid/cancel broadcasts update this page live.
export default class extends ApplicationController {
  connect() {
    super.connect()

    const auctionItemId = this.element.dataset.auctionItemId
    if (!auctionItemId) return

    consumer.subscriptions.create({ channel: 'AuctionItemChannel', auction_item_id: auctionItemId }, {
      received: (data) => {
        if (!data.cableReady) return
        CableReady.perform(data.operations)
        fixBidderIdFields()
        fixCurrentUserIdFields()
        refreshOutbidIndicator()
      },
    })
  }
}

function fixBidderIdFields() {
  if (!window.givsum_user_id) return
  document.querySelectorAll('input[name="bidder_id"]').forEach((field) => {
    if (!field.value || String(field.value) !== String(window.givsum_user_id)) {
      field.value = window.givsum_user_id
    }
  })
}

// Broadcast bakes in whoever just bid as current_user, corrupting other viewers' cancel-bid
// rows (data-current-user-id) — re-stamp with the real viewer's id after every broadcast.
function fixCurrentUserIdFields() {
  if (!window.givsum_user_id) return
  document.querySelectorAll('[data-current-user-id]').forEach((el) => {
    if (String(el.dataset.currentUserId) !== String(window.givsum_user_id)) {
      el.dataset.currentUserId = window.givsum_user_id
    }
  })
}

function refreshOutbidIndicator() {
  const indicator = document.getElementById('outbid_indicator')
  if (!indicator) return
  try {
    const myBids = JSON.parse(localStorage.getItem('userBids') || '[]')
    const hasOutbids = myBids.some((bid) => bid.winning_bid === false)
    indicator.classList.toggle('d-none', !hasOutbids)
  } catch (e) {
    // malformed localStorage, ignore
  }
}
